import { Component } from "@angular/core";
import { NotificationsService } from "../notifications.service";

@Component({
    selector: 'tyt-notifications-button',
    templateUrl: './notifications-button.component.html',
    styleUrls: ['./notifications-button.component.scss']
})
export class NotificationsButtonComponent {
    constructor(
        private notifications: NotificationsService
    ) {
    }

    get count() {
        return this.notifications.count;
    }

    get listVisible() {
        return this.notifications.visible;
    }

    toggleList() {
        if (this.listVisible)
            this.notifications.closeList();
        else
            this.notifications.showList();
    }
}